import React, { Fragment } from 'react';
import { Route } from 'react-router';
import { Container } from 'reactstrap';

import '../assets/styles/style';
import '../assets/styles/application';

import Header from '../components/Header';
import Footer from '../components/Footer';
import Messages from '../components/Messages';

import { IS_APP } from '../services/target';

export default ({ page }) => (
  <Fragment>
    {!IS_APP && <Header />}
    <Messages />
    <Container>
      <Route component={page} />
    </Container>
    {!IS_APP && <Footer />}
  </Fragment>
);



// WEBPACK FOOTER //
// ./src/layouts/application.js